import React from "react";
import { Link } from "redux-little-router";
import ProfilePicture from "../../../../components/ProfilePicture";
import "./index.css";

const PostCardHeader = ({ owner: { id, name, picture, speciality }, profilePath, children }) => (
  <header className="card-header">
    <Link href={profilePath}>
      <ProfilePicture userId={id} size="s" fallbackUrl={picture} alt={name} className="-user-img" />
    </Link>
    <div className="-card-data">
      <Link href={profilePath} className="-user-name">
        {name}
      </Link>
      {speciality && speciality !== "Other" && <p className="-user-speciality">{speciality}</p>}
    </div>
    {children}
  </header>
);

export default PostCardHeader;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/PostCardHeader/index.js